export default "__VITE_ASSET__42cec654__"